<shared-indicator [inverted]="inverted" [size]="size" [feel]="feel" class="order-id">
    <div class="order-id__content">
        <div class="order-id__title" *ngIf="title">{{title}}</div>
        <div class="order-id__number" *ngIf="orderId">
            {{orderId}}
        </div>
    </div>
</shared-indicator>